import {
  RootFactory,
  ServicesFactory,
  TestimonialsFactory,
  ContactFactory,
  PortfolioFactory,
  PortfolioFiltersFactory,
} from '../factories';

export const vlavaBuilder = () => {
  return {
    buildTemplate: (website) => ({
      theme: "vlava",
      ...RootFactory.getVlava(website),
      services: ServicesFactory.getButterfly(website),
      testimonials: TestimonialsFactory.getBase(website),
      constact: ContactFactory.getBase(website),
      portfolio: PortfolioFactory.getBase(website),
      portfolioFilters: PortfolioFiltersFactory.getBase(website),
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/builders/VlavaBuilder.js